module.exports = __webpack_public_path__ + "img/UY4.5470b018.png";